import { useId, type ReactNode } from 'react';
import { classes } from '../outils/classes';
import styles from './Panneau.module.css';

export interface ProprietesPanneau {
  titre?: ReactNode;
  /** Niveau du titre (2 par défaut). */
  niveau?: 2 | 3;
  actions?: ReactNode;
  children: ReactNode;
  /** Note interne : fond distinct et mention « Interne, invisible par l'usager ». */
  interne?: boolean;
  sansMarge?: boolean;
  className?: string;
  id?: string;
}

export function Panneau({ titre, niveau = 2, actions, children, interne, sansMarge, className, id }: ProprietesPanneau) {
  const idTitre = useId();
  const Titre = niveau === 2 ? 'h2' : 'h3';
  return (
    <section
      id={id}
      className={classes(styles.panneau, interne && styles.interne, sansMarge && styles.sansMarge, className)}
      aria-labelledby={titre ? idTitre : undefined}
    >
      {titre || actions ? (
        <div className={styles.entete}>
          <div>
            {titre ? <Titre id={idTitre}>{titre}</Titre> : null}
            {interne ? <p className={styles.mention}>Interne, invisible par l&apos;usager</p> : null}
          </div>
          {actions ? <div className={styles.actions}>{actions}</div> : null}
        </div>
      ) : null}
      <div className={styles.corps}>{children}</div>
    </section>
  );
}
